import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=294fa1fe&scoped=true&"
import script from "./factory.vue?vue&type=script&lang=js&"
export * from "./factory.vue?vue&type=script&lang=js&"
import style0 from "./factory.vue?vue&type=style&index=0&id=294fa1fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294fa1fe",
  null
  
)

export default component.exports